import { createRoute } from '@tanstack/react-router'
import rootRoute from './rootRoute'
import ContactForm from '@/components/ContactForm'

const ContactPage = () => {
  return (
    <div
      style={{
        maxWidth: 1000,
        margin: '0 auto',
        padding: 'var(--space-12) var(--gutter) var(--space-20)',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: 'var(--space-12)' }}>
        <div className="oumma-overline" style={{ marginBottom: 12 }}>
          Nous contacter
        </div>
        <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 12px' }}>
          Une question ? Écrivez-nous
        </h1>
        <p
          style={{
            fontSize: 'var(--text-lead)',
            color: 'var(--ink-2)',
            maxWidth: 520,
            margin: '0 auto',
          }}
        >
          Nous lisons chaque message et répondrons le plus vite possible, in
          shaa Allah.
        </p>
      </div>

      <ContactForm />
    </div>
  )
}

export const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
}).lazy(() => import('./ContactPage.lazy').then((m) => m.Route))

export default ContactPage
